import { render, staticRenderFns } from "./Swiper.htm?vue&type=template&id=f6caf216&scoped=true&"
import script from "./Swiper.js?vue&type=script&lang=js&"
export * from "./Swiper.js?vue&type=script&lang=js&"
import style0 from "./Swiper.scss?vue&type=style&index=0&id=f6caf216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6caf216",
  null
  
)

export default component.exports